export default __webpack_public_path__ + "static/media/jabeh_logo.1324f61b.svg";